'use strict';
/* ════════════════════════════════════════
   WOODENXA — wx-pp.js
   Product Page Interactivity
   ════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function() {

  /* ── GALLERY ── */
  var slides   = document.querySelectorAll('.gal-sl');
  var thumbs   = document.querySelectorAll('.gal-th');
  var dots     = document.querySelectorAll('.gal-dot');
  var curIdx   = 0;

  function showSlide(i) {
    slides.forEach(function(s,idx){ s.classList.toggle('on', idx===i); });
    thumbs.forEach(function(t,idx){ t.classList.toggle('on', idx===i); });
    dots.forEach(function(d,idx){ d.classList.toggle('on', idx===i); });
    curIdx = i;
  }

  thumbs.forEach(function(th, i){
    th.addEventListener('click', function(){ showSlide(i); });
  });
  dots.forEach(function(d, i){
    d.addEventListener('click', function(){ showSlide(i); });
  });

  var prev = document.querySelector('.gal-prev');
  var next = document.querySelector('.gal-next');
  if (prev) prev.addEventListener('click', function(){ showSlide((curIdx - 1 + slides.length) % slides.length); });
  if (next) next.addEventListener('click', function(){ showSlide((curIdx + 1) % slides.length); });

  // Touch swipe
  var gMain = document.querySelector('.gal-main');
  if (gMain) {
    var sx = 0;
    gMain.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; }, {passive:true});
    gMain.addEventListener('touchend', function(e){
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) showSlide(dx < 0 ? (curIdx+1)%slides.length : (curIdx-1+slides.length)%slides.length);
    }, {passive:true});
  }

  /* ── VARIANT SELECTOR ── */
  var vpills = document.querySelectorAll('.vpill');
  var variantInput = document.getElementById('variantId');
  var priceEl = document.getElementById('ppPrice');

  vpills.forEach(function(pill){
    pill.addEventListener('click', function(){
      var idx = pill.dataset.idx;
      document.querySelectorAll('.vpill[data-idx="'+idx+'"]').forEach(function(p){ p.classList.remove('on'); });
      pill.classList.add('on');
      var lbl = document.getElementById('vLbl'+idx);
      if (lbl) lbl.textContent = pill.dataset.val;

      // Find matching variant
      if (!window.__pd) return;
      var selected = [];
      document.querySelectorAll('.vpill.on').forEach(function(p){ selected[parseInt(p.dataset.idx)] = p.dataset.val; });
      var match = window.__pd.variants.find(function(v){
        return v.options.every(function(o, i){ return o === selected[i]; });
      });
      if (match) {
        if (variantInput) variantInput.value = match.id;
        var atcBtn = document.getElementById('ppAtc');
        if (atcBtn) { atcBtn.dataset.vid = match.id; atcBtn.disabled = !match.available; }
        var buyBtn = document.getElementById('ppBuy');
        if (buyBtn) buyBtn.dataset.vid = match.id;
        if (priceEl) {
          var curr = match.price, comp = match.compare_at_price;
          var disc = comp > curr ? Math.round((comp-curr)*100/comp) : 0;
          priceEl.innerHTML = '<div class="price-row">' +
            '<span class="price-curr' + (comp>curr ? ' sale' : '') + '">' + fmoney(curr) + '</span>' +
            (comp > curr ? '<span class="price-orig">' + fmoney(comp) + '</span><span class="price-disc">SAVE '+disc+'%</span>' : '') +
          '</div>';
        }
        // Update sticky ATC
        var sPrice = document.querySelector('.sticky-atc-price');
        if (sPrice) sPrice.textContent = fmoney(match.price);
        // Update buy now text
        if (buyBtn) buyBtn.textContent = '⚡ Buy Now — ' + fmoney(match.price);
      }
    });
  });

  /* ── QTY ── */
  var qtyNum = document.getElementById('ppQty');
  var qtyDec = document.getElementById('ppQtyDec');
  var qtyInc = document.getElementById('ppQtyInc');
  if (qtyDec && qtyNum) qtyDec.addEventListener('click', function(){ var v=parseInt(qtyNum.value); if(v>1) qtyNum.value=v-1; });
  if (qtyInc && qtyNum) qtyInc.addEventListener('click', function(){ var v=parseInt(qtyNum.value); if(v<99) qtyNum.value=v+1; });

  /* ── MAIN ATC ── */
  var ppAtc = document.getElementById('ppAtc');
  if (ppAtc) {
    ppAtc.addEventListener('click', function(){
      var vid = parseInt(variantInput ? variantInput.value : ppAtc.dataset.vid);
      var qty = parseInt(qtyNum ? qtyNum.value : 1) || 1;
      WX.addToCart(vid, qty, ppAtc);
    });
  }

  /* ── BUY NOW ── */
  var ppBuy = document.getElementById('ppBuy');
  if (ppBuy) {
    ppBuy.addEventListener('click', function(){
      var vid = variantInput ? variantInput.value : ppBuy.dataset.vid;
      if (!vid) return;
      fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id:parseInt(vid), quantity:1}) })
      .then(function(){ window.location.href = '/checkout'; });
    });
  }

  /* ── STICKY ATC ── */
  var stickyAtc = document.getElementById('stickyAtc');
  var ppForm = document.querySelector('.pp-form-area');
  if (stickyAtc && ppForm) {
    var io = new IntersectionObserver(function(entries){ stickyAtc.classList.toggle('vis', !entries[0].isIntersecting); }, {threshold:.1});
    io.observe(ppForm);
  }
  var stickyBtn = document.getElementById('stickyAtcBtn');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function(){
      var vid = parseInt(variantInput ? variantInput.value : stickyBtn.dataset.vid);
      WX.addToCart(vid, 1, stickyBtn);
    });
  }

  /* ── FBT ── */
  var fbtSection = document.querySelector('.fbt-wrap');
  if (fbtSection) {
    var cbs = fbtSection.querySelectorAll('.fbt-prod input[type=checkbox]');
    var totalEl = fbtSection.querySelector('.fbt-total-txt strong');
    var saveEl  = fbtSection.querySelector('.fbt-save');

    function calcFbt() {
      var total = 0, orig = 0;
      cbs.forEach(function(cb){
        if (cb.checked) {
          total += parseInt(cb.dataset.price || 0);
          orig  += parseInt(cb.dataset.compare || cb.dataset.price || 0);
        }
        cb.closest('.fbt-prod').classList.toggle('sel', cb.checked);
      });
      if (totalEl) totalEl.textContent = fmoney(total);
      if (saveEl) {
        var saved = orig - total;
        if (saved > 0) { saveEl.style.display='inline'; saveEl.textContent='Save '+fmoney(saved); }
        else saveEl.style.display='none';
      }
    }

    cbs.forEach(function(cb){
      cb.closest('.fbt-prod').addEventListener('click', function(e){
        if (e.target !== cb) cb.checked = !cb.checked;
        calcFbt();
      });
    });

    var fbtBtn = fbtSection.querySelector('.fbt-atc');
    if (fbtBtn) {
      fbtBtn.addEventListener('click', function(){
        var items = [];
        cbs.forEach(function(cb){ if(cb.checked && cb.dataset.vid) items.push({id:parseInt(cb.dataset.vid),quantity:1}); });
        if (!items.length) return;
        var orig2 = fbtBtn.textContent;
        fbtBtn.textContent = 'Adding...'; fbtBtn.disabled = true;
        var addNext = function(i) {
          if (i >= items.length) {
            fbtBtn.textContent = '✓ Added to Cart'; fbtBtn.style.background='#2D6A4F';
            setTimeout(function(){ fbtBtn.textContent=orig2; fbtBtn.style.background=''; fbtBtn.disabled=false; WX.openCart(); }, 1600);
            return;
          }
          fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(items[i])})
          .then(function(){ addNext(i+1); }).catch(function(){ addNext(i+1); });
        };
        addNext(0);
      });
    }
    calcFbt();
  }

  /* ── BUNDLE ── */
  document.querySelectorAll('.bundle-opt').forEach(function(opt){
    opt.addEventListener('click', function(){
      document.querySelectorAll('.bundle-opt').forEach(function(o){ o.classList.remove('sel'); });
      opt.classList.add('sel');
      var r = opt.querySelector('input[type=radio]'); if(r) r.checked=true;
      var vid = opt.dataset.vid;
      if (variantInput && vid) variantInput.value = vid;
    });
  });

  /* ── DISCOUNT PANEL TOGGLE ── */
  var discBtn = document.getElementById('discToggle');
  var discPanel = document.getElementById('discPanel');
  if (discBtn && discPanel) {
    discBtn.addEventListener('click', function(){
      var isOpen = discPanel.classList.toggle('open');
      discBtn.textContent = isOpen ? '✕ Hide Discounts' : '🎯 Need More Discount?';
    });
  }

  /* ── BANK DETAILS POPUP ── */
  var bankBtn = document.getElementById('bankDetailsBtn');
  var bankOverlay = document.getElementById('bankOverlay');
  var bankClose = document.getElementById('bankClose');

  if (bankBtn && bankOverlay) {
    bankBtn.addEventListener('click', function(){
      bankOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }
  function closeBankPopup() {
    if (bankOverlay) { bankOverlay.classList.remove('open'); document.body.style.overflow = ''; }
  }
  if (bankClose) bankClose.addEventListener('click', closeBankPopup);
  if (bankOverlay) bankOverlay.addEventListener('click', function(e){ if(e.target === bankOverlay) closeBankPopup(); });

  /* ── COPY TO CLIPBOARD ── */
  document.querySelectorAll('.bank-copy').forEach(function(el){
    el.addEventListener('click', function(){
      var txt = el.dataset.copy;
      if (!txt) return;
      navigator.clipboard.writeText(txt).then(function(){
        el.classList.add('copied');
        var orig = el.innerHTML;
        el.innerHTML = '✓ Copied!';
        setTimeout(function(){ el.innerHTML = orig; el.classList.remove('copied'); }, 1800);
      }).catch(function(){
        // Fallback
        var ta = document.createElement('textarea');
        ta.value = txt; ta.style.position='fixed'; ta.style.opacity='0';
        document.body.appendChild(ta); ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      });
    });
  });

  /* ── URGENCY (product page) ── */
  var ppStock = document.querySelector('.pp-stock-count');
  if (ppStock) ppStock.textContent = [4,5,6,7,8][Math.floor(Math.random()*5)];
  var ppDelivDate = document.querySelector('.pp-deliv-date');
  if (ppDelivDate) {
    var dd = new Date(); dd.setDate(dd.getDate() + (dd.getDay() >= 4 ? 7 : 4));
    var days2 = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    var months2 = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    ppDelivDate.textContent = 'Get it by ' + days2[dd.getDay()] + ', ' + months2[dd.getMonth()] + ' ' + dd.getDate();
  }

  /* ── MINI REVIEWS ROTATOR ── */
  var mrs = document.querySelectorAll('.mini-rev');
  if (mrs.length > 1) {
    var mri = 0;
    setInterval(function(){
      mrs[mri].style.display = 'none';
      mri = (mri+1) % mrs.length;
      mrs[mri].style.display = 'flex';
    }, 4200);
  }

  /* ── HELPER ── */
  function fmoney(cents) {
    return 'Rs.\u00a0' + Math.round(cents/100).toLocaleString('en-PK');
  }


  /* ── IMAGE ZOOM ON CLICK ── */
  var zoomModal = document.getElementById('galZoomModal');
  var zoomImg   = document.getElementById('galZoomImg');
  var zoomClose = document.getElementById('galZoomClose');

  function openZoom(src) {
    if (!zoomModal || !zoomImg) return;
    zoomImg.src = src.replace(/width=\d+/, 'width=1200');
    zoomModal.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeZoom() {
    if (!zoomModal) return;
    zoomModal.classList.remove('open');
    document.body.style.overflow = '';
  }

  // Click on main gallery image to zoom
  var galMain = document.querySelector('.gal-main');
  if (galMain) {
    galMain.addEventListener('click', function(e) {
      var activeSlide = document.querySelector('.gal-sl.on img');
      if (activeSlide) openZoom(activeSlide.src);
    });
  }
  if (zoomClose) zoomClose.addEventListener('click', closeZoom);
  if (zoomModal) zoomModal.addEventListener('click', function(e) {
    if (e.target === zoomModal || e.target === zoomImg) closeZoom();
  });
  // ESC key
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') { closeZoom(); closeBankPopup(); } });


});